const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "holideviser_admin_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => localStorage.setItem(KEY, t);
export const clearToken = () => localStorage.removeItem(KEY);

export const STATUS_LIST = [
  "NEW",
  "REVIEWING",
  "PLANNING",
  "READY TO SEND",
  "SENT",
  "FOLLOW-UP",
  "CONVERTED",
  "CLOSED",
];

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

async function req(path, opts = {}) {
  const res = await fetch(BASE + path, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
      ...(opts.headers || {}),
    },
  });
  if (res.status === 401) {
    clearToken();
    throw new Error("Unauthorized");
  }
  if (!res.ok) {
    const e = await res.json().catch(() => ({ detail: "Something went wrong" }));
    throw new Error(typeof e.detail === "string" ? e.detail : "Something went wrong");
  }
  return res.json();
}

export const adminLogin = (email, password) =>
  req("/admin/login", { method: "POST", body: JSON.stringify({ email, password }) });
export const fetchStats = () => req("/admin/stats");
export const fetchTrips = (qs) => req("/admin/trips" + (qs ? `?${qs}` : ""));
export const fetchTrip = (id) => req(`/admin/trips/${id}`);
export const updateStatus = (id, status) =>
  req(`/admin/trips/${id}/status`, { method: "PATCH", body: JSON.stringify({ status }) });
export const addNote = (id, text) =>
  req(`/admin/trips/${id}/notes`, { method: "POST", body: JSON.stringify({ text }) });
export const updateNextAction = (id, next_action, next_action_date) =>
  req(`/admin/trips/${id}/next-action`, {
    method: "PATCH",
    body: JSON.stringify({ next_action, next_action_date }),
  });

// ---- Holideviser Edit (Trip Builder) ----
export const getEdit = (tripId) => req(`/admin/trips/${tripId}/edit`);
export const createEdit = (tripId) => req(`/admin/trips/${tripId}/edit`, { method: "POST" });
export const saveEdit = (editId, payload) =>
  req(`/admin/edits/${editId}`, { method: "PUT", body: JSON.stringify(payload) });
export const publishEdit = (editId) => req(`/admin/edits/${editId}/publish`, { method: "POST" });
export const unpublishEdit = (editId) => req(`/admin/edits/${editId}/unpublish`, { method: "POST" });
